import React, {Fragment} from 'react';
import fbIcon from '../../assets/fb.png';
import linkIcon from '../../assets/link.png';
import ReactHtmlParser from 'react-html-parser';

const Content = ({blog}) => {
  return (
    <Fragment>
      <div className="pb-3 mb-5" style={{borderBottom: '1px solid rgba(0,0,0,0.12)'}}>
        <p style={{fontSize: '25px', fontWeight: '600'}}>{blog.title}</p>
        <div className="d-flex" style={{justifyContent: 'space-between'}}>
          <p className="text-muted mt-2" style={{fontSize: '12px'}}>Penulis : {blog.author}, Kategori : {blog.category}</p>
          <div className="row mx-0" style={{justifyContent: 'flex-end'}}>
            {/* <a href="" className="mr-3">
              <img src={fbIcon} alt="fb" style={{width: '25px', height: '25px'}}/>
            </a> */}
            <a href="">
              <img src={linkIcon} alt="link" style={{width: '25px', height: '25px'}}/>
            </a>
          </div>
        </div>
      </div>
      <p style={{fontSize: '13px'}}>
        {ReactHtmlParser(blog.content)}
      </p>
    </Fragment>
  )
}

export default Content